import { useEffect, useState } from 'react';
import classNames from 'classnames/bind';
import styles from './Faq.module.css';

import { useGetFaqQuery } from '../../../services/settings';
import { ALL, ETC, FAQ, MEMBER } from '../../../constants';
import { FaqItem } from '../../../types/settings';
import TableBody from '../../../components/TableBody/TableBody';

export default function Faq() {
  const cx = classNames.bind(styles);
  const [selectedCode, setSelectedCode] = useState('');
  const [selectedList, setSelectedList] = useState<FaqItem[]>([]);
  const { data: faqList, isLoading } = useGetFaqQuery({
    faqCd: selectedCode,
    page: 0,
  });

  const codeList = [
    ['', ALL],
    ['T0301', MEMBER],
    ['T0302', 'Cloud'],
    ['T0303', 'Viewer'],
    ['T0304', 'Creator'],
    ['T0399', ETC],
  ];

  const selectType = (code: string) => {
    setSelectedCode(code);
  };

  useEffect(() => {
    faqList && setSelectedList(faqList);
  }, [faqList]);

  if (isLoading) return null;

  return (
    <>
      <h2>{FAQ}</h2>
      <div className={cx('nav_sub_items')}>
        {codeList.map(([code, name]) => (
          <span
            key={code}
            className={cx('btn', 'items', { on: code === selectedCode })}
            onClick={() => selectType(code)}
          >
            {name}
          </span>
        ))}
      </div>
      <TableBody name="faq" list={selectedList} code={selectedCode} />
    </>
  );
}
